// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ICheckEstimationExistsRequest,
  TCheckEstimationExistsModel,
  IMappers,
  TCheckEstimationExistsResponse,
  ICheckEstimationExistsResponse,
  ICheckEstimationExistsResponseError,
} from './types';

export const defaultConfig: TCheckEstimationExistsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v1/check-estimation-exists/',
  requestType: 'json',
} as TCheckEstimationExistsModel;

export function createCheckEstimationExistsModel(
  parameters: ICheckEstimationExistsRequest,
): TCheckEstimationExistsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICheckEstimationExistsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ICheckEstimationExistsRequest;
}

export async function fetchCheckEstimationExists<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICheckEstimationExistsOptions<TResponse200, TResponse400>): Promise<
  TCheckEstimationExistsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createCheckEstimationExistsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICheckEstimationExistsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ICheckEstimationExistsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCheckEstimationExistsResponse;
}
